.package-dropdown {
  > div {
    width: 100%;
  }
}
